import React from 'react';
import classnames from 'classnames';
import { workBench } from '@codametrix/ui-common';
import { AppliedClassNames } from '../applied-class-names';
import evaluateEnablerRules from './field-enabler-rules';
const { getValueAtPath } = workBench.pathUtils;

const TextInputComponent: React.FC<{
  field: CMxCommonApp.TextInputField;
  value: object;
}> = ({ field, value }) => {
  const [firstClass, ...rest] = field.classNames;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const userInputValue = event.target.value;

    if (userInputValue !== '' && field.validateInputString) {
      const regex = new RegExp(field.validateInputString);
      if (!regex.test(userInputValue)) {
        return;
      }
    }

    field.onKeyPress(Number(userInputValue), value, field);
  };

  let isEnabled = true;

  if (field.inputEnableRules && field.inputEnableRules.length > 0) {
    isEnabled = evaluateEnablerRules(field.inputEnableRules, value, 'OR');
  }

  const textInputComponent = (
    <input
      onBlur={() => {}}
      type="text"
      disabled={!isEnabled}
      value={value['units']}
      className={classnames(firstClass)}
      onChange={handleChange}
      data-testid="input-field-units"
    />
  );

  return <AppliedClassNames value={textInputComponent} classNames={rest} />;
};

export default TextInputComponent;
